/** One titled card. `hint` is a one-line reading guide under the title: what
 *  the chart counts and over which period, so nobody has to guess. */
const StatCard = ({ title, hint, children, className = "", aside }) => (
  <section className={`ws-card ${className}`}>
    <header className="ws-card__head">
      <div>
        <h3 className="ws-card__title">{title}</h3>
        {hint && <p className="ws-card__hint">{hint}</p>}
      </div>
      {aside}
    </header>
    <div className="ws-card__body">{children}</div>
  </section>
);

/** A titled group of cards. */
export const Section = ({ title, children }) => (
  <section className="ws-section" aria-label={title}>
    <h2 className="ws-section__title">{title}</h2>
    {children}
  </section>
);

export const Empty = ({ children = "No data for this selection." }) => (
  <div className="ws-empty">{children}</div>
);

export default StatCard;
